import React from 'react';
import { WizardCard } from './fdicChrome';

const CheckSeal = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 12.5l2.5 2.5L16 9.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const fmtDate = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
};

const Row = ({ label, value, highlight }) => (
  <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 last:border-b-0 gap-4">
    <span className="text-[13px] text-gray-500">{label}</span>
    <span className={`text-[15px] font-semibold text-right ${highlight ? 'text-[#1a4b8c]' : 'text-[#1a2b3c]'}`}>
      {value || '—'}
    </span>
  </div>
);

const Step1RecordFound = ({ data, onNext }) => (
  <WizardCard headerIcon={<CheckSeal />} headerLabel="Record Found">
    <div>
      <Row label="Full Name"         value={data.fullName} />
      <Row label="Case ID"           value={data.caseId} highlight />
      <Row label="Date Retrieved"    value={fmtDate(data.dateRetrieved)} />
      <Row label="Assigned Support"  value={data.assignedSupport} />
    </div>

    <div className="p-5">
      <button
        onClick={onNext}
        className="w-full bg-[#0b2740] hover:bg-[#12324f] text-white text-[13px] font-semibold tracking-[0.15em] uppercase py-4 rounded-md"
      >
        View Financials
      </button>
    </div>
  </WizardCard>
);

export default Step1RecordFound;